if (!customElements.get('size-chart')) {
  customElements.define('size-chart', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const unit = event.target.closest('[data-unit-button]');
        const group = event.target.closest('[data-group-button]');

        if (unit) this.setUnit(unit.dataset.unitButton);
        if (group) this.setGroup(group.dataset.groupButton);
      });

      const measure = this.querySelector('.size-chart__measure');

      if (!measure) return;

      const items = measure.querySelectorAll('[data-measure-item]');
      const set = (name) => {
        if (name) measure.dataset.active = name;
        else delete measure.dataset.active;

        items.forEach((item) => item.classList.toggle('is-active', item.dataset.measureItem === name));
      };

      items.forEach((item) => {
        const name = item.dataset.measureItem;

        item.addEventListener('mouseenter', () => set(name));
        item.addEventListener('focus', () => set(name));
        item.addEventListener('mouseleave', () => set(null));
        item.addEventListener('blur', () => set(null));
      });

      measure.querySelectorAll('.size-chart__mark').forEach((mark) => {
        mark.addEventListener('mouseenter', () => set(mark.dataset.measure));
        mark.addEventListener('mouseleave', () => set(null));
      });
    }

    setUnit(unit) {
      this.dataset.unit = unit;

      this.querySelectorAll('[data-unit-button]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.unitButton === unit));
      });
    }

    setGroup(group) {
      this.dataset.group = group;

      this.querySelectorAll('[data-group-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.groupPanel !== group;
      });

      this.querySelectorAll('[data-group-button]').forEach((button) => {
        button.setAttribute('aria-selected', String(button.dataset.groupButton === group));
      });
    }
  });
}
